// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#crop-logo[data-v-0bf52880] {\n  width: 123px;\n  height: 123px;\n  overflow: hidden;\n  position: relative;\n  border: 4px solid #fff;\n  border-radius: 100%;\n  background: #f5f5f5;\n}\n#crop-logo img[data-v-0bf52880] {\n  position: absolute;\n  min-width: 203px;\n  height: 114px;\n  left: -44px;\n  top: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
